module.exports = __webpack_public_path__ + "img/slow_loader.3cf3da56.svg";